import React from "react";
import {Modal} from "react-bootstrap";
import {KTSVG, WithChildren} from "../../../../_metronic/helpers";

interface Props extends WithChildren {
    onClose: () => void
}
export function FormDataErrorModal({children, onClose}: Props) {
    return (
        <Modal
            className='modal-sticky modal-sticky-lg modal-sticky-bottom-right shadow'
            id='kt_main_modal'
            role='dialog'
            backdrop="static"
            tabIndex='-1'
            show={true}
            animation={false}
            size='sm'
            centered
        >
            <div className='modal-content'>
                <div className='modal-header'>
                    <h5 className='modal-title'>Request Error</h5>
                    {/* begin::Close */}
                    <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={onClose}>
                        <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg'/>
                    </div>
                    {/* end::Close */}
                </div>
                <div className="modal-body">
                    {children}
                </div>
            </div>
        </Modal>
    )
}